import { render } from "./IndividualProduct.vue?vue&type=template&id=644461ea&scoped=true&ts=true"
import script from "./IndividualProduct.vue?vue&type=script&lang=ts"
export * from "./IndividualProduct.vue?vue&type=script&lang=ts"

import "./IndividualProduct.vue?vue&type=style&index=0&id=644461ea&scoped=true&lang=css"

import exportComponent from "D:\\YellowBeardProject\\selecta\\selectashopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-644461ea"]])

export default __exports__